import { SESSION_EXPIRED } from '../../actions/types';
// Imported directly (not via a barrel) so this stays a tiny leaf module: the
// unified session-expiry guard that every non-RTK/non-axios HTTP client shares,
// instead of each one re-inlining the same store read + dispatch.
import store from '../../store';

/**
 * Whether the Keycloak session has already been flagged as expired (the unified
 * SessionExpiredModal is showing). Clients use this to fail fast instead of
 * firing a request that is guaranteed to 401.
 */
export function isSessionExpired(): boolean {
  return store.getState().keycloak.sessionExpired;
}

/**
 * Opens the unified SessionExpiredModal when an authenticated request comes back
 * 401. The guard makes concurrent 401s converge on a single dispatch.
 *
 * Returns whether the status was a 401 — i.e. an expiry signal — so callers can
 * suppress their own per-page error copy and let the modal take over. A non-401
 * status (or `undefined`, e.g. a network error with no HTTP response) is a no-op.
 */
export function dispatchSessionExpiredIfUnauthorized(status: number | undefined): boolean {
  if (status !== 401) {
    return false;
  }
  if (!isSessionExpired()) {
    store.dispatch({ type: SESSION_EXPIRED });
  }
  return true;
}
